import fetchAPI from 'utils/fetchAPI';

export const getInvoice = ({
  email,
  name,
  company,
  account,
  amount,
  paymentDate,
  plan,
  start,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/internal/invoices/preview',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        customer_email: email,
        customer_name: name,
        customer_company: company,
        no_account: account,
        total_amount: amount,
        payment_date: paymentDate,
        payment_term: plan,
        valid_from: start,
      }),
    }).then(res => {
      if (res.status !== 200) return reject();
      return res.json().then(json => resolve(json.url));
    });
  });

export const sendInvoice = ({
  email,
  name,
  company,
  account,
  amount,
  paymentDate,
  plan,
  start,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/internal/invoices',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        customer_email: email,
        customer_name: name,
        customer_company: company,
        no_account: account,
        total_amount: amount,
        payment_date: paymentDate,
        payment_term: plan,
        valid_from: start,
      }),
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) return resolve();
        return reject();
      });
  });



// WEBPACK FOOTER //
// ./app/actions/InvoiceActionCreators.js